import React from 'react';
import './DashboardBar.css';
import { Link } from 'react-router-dom';
import ConsoleLog from '../../../hoc/ConsoleLog/ConsoleLog';
import Tabs from '../../../components/UI/Tabs/Tabs';

/**
 * @desc Shows Recruiter dashboard contents
 * @param props
 * @return DOMElement
 */
const DashboardBar = (props) => {
  const pathname = window.location.href.split('/');
  const RecruitersActiveClass = (pathname[4] === "recruiter" || pathname[4] === "dashboard" ) ? 'active' : 'inactive';
  const ClientsActiveClass = (pathname[4] === "client") ? 'active' : 'inactive'
  return (
    <div className="admin-dashboard-bar">
    
      <Link className={RecruitersActiveClass + ' dashboard'} to="/admin/recruiter">Recruiters</Link>
      <Link className={ClientsActiveClass + ' dashboard'} to="/admin/client">Clients</Link>  
    </div>
    
  );
}

DashboardBar.defaultProps = { 
  activeLink: 'recruiters',
};

export default DashboardBar;


// WEBPACK FOOTER //
// ./src/container/Admin/DashboardBar/DashboardBar.js